import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateRangePickerStyled, theme } from "./date-range-picker.styles";
import { ThemeProvider } from "@mui/material/styles";
import { Controller } from "react-hook-form";
import { Box, Typography } from "@mui/material";

export const DateRangePickerField = ({
  label = "",
  value,
  onChange,
  views,
  error,
  defaultValue,
}: any) => {
  return (
    <ThemeProvider theme={theme}>
      <DateRangePickerStyled>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box>
            {label && (
              <Typography
                className="label"
                variant="body2"
                sx={{ marginBottom: "4px" }}
              >
                {label}
              </Typography>
            )}
            <DatePicker
              views={views}
              value={value}
              onChange={onChange}
              defaultValue={defaultValue}
              slotProps={{
                textField: { variant: "outlined", size: "small", error },
              }}
            />
            {error && (
              <Typography variant="caption" color="error">
                {error}
              </Typography>
            )}
          </Box>
        </LocalizationProvider>
      </DateRangePickerStyled>
    </ThemeProvider>
  );
};

export const DateRangePickerFormField = (props: any) => {
  const { name, defaultValue, control  } = props;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <DateRangePickerField
            {...props}
            value={value}
            error={error}
            onChange={onChange}
          />
        );
      }}
    />
  );
};
